import React, { createContext, useState, ReactNode } from 'react';

interface SideBarContextType {
  menuVisible: boolean;
  setMenuVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SideBarContext = createContext<SideBarContextType>({
  menuVisible: false,
  setMenuVisible: () => {},
});

interface SideBarProviderProps {
  children: ReactNode;
}

export const SideBarProvider: React.FC<SideBarProviderProps> = ({ children }) => {
  const [menuVisible, setMenuVisible] = useState(false);

  return <SideBarContext.Provider value={{ menuVisible, setMenuVisible }}>{children}</SideBarContext.Provider>;
};
